import { Alert, Button, CircularProgress, Fade, Paper, Stack, Typography } from "@mui/material";

// Save bar shown only while there are unsaved changes. Place it last in the section: it sticks to the
// bottom of the screen while scrolling, aligned with the form (same width), not centred on the page.
export const UnsavedChangesBar = ({
  open,
  saving,
  error,
  onDiscard,
  onSave,
}: {
  open: boolean;
  saving: boolean;
  error?: string | null;
  onDiscard: () => void;
  onSave: () => void;
}) => (
  <Fade in={open} unmountOnExit>
    <Paper
      elevation={0}
      sx={{
        position: "sticky",
        bottom: { xs: 12, sm: 16 },
        zIndex: (theme) => theme.zIndex.appBar - 1,
        borderRadius: 3,
        border: "1px solid #e5e7eb",
        boxShadow: "0 16px 40px rgba(15, 23, 42, 0.16)",
        p: { xs: 1.5, sm: 2 },
      }}
    >
      {error && (
        <Alert severity="error" sx={{ mb: 1.5, borderRadius: 2 }}>
          {error}
        </Alert>
      )}
      <Stack direction={{ xs: "column", sm: "row" }} alignItems={{ xs: "stretch", sm: "center" }} spacing={1.5}>
        <Typography sx={{ flex: 1, fontWeight: 600, fontSize: 14.5, color: "#0f172a" }}>You have unsaved changes</Typography>
        <Stack direction="row" spacing={1}>
          <Button onClick={onDiscard} disabled={saving} sx={{ flex: { xs: 1, sm: "none" }, textTransform: "none", fontWeight: 600, borderRadius: 2 }}>
            Discard
          </Button>
          <Button
            variant="contained"
            onClick={onSave}
            disabled={saving}
            startIcon={saving ? <CircularProgress size={16} color="inherit" /> : undefined}
            sx={{ flex: { xs: 1, sm: "none" }, textTransform: "none", fontWeight: 600, borderRadius: 2, boxShadow: "none" }}
          >
            {saving ? "Saving…" : "Save changes"}
          </Button>
        </Stack>
      </Stack>
    </Paper>
  </Fade>
);
